export default {
    // 接口调用成功状态码
    // SUCCESS_CODE: "0",
    // LOADING_CONFIG: {
    //     iconUrl: '', //icon图片地址
    //     borderRadius: '20%',
    //     padding: '1',
    //     fade:true
    // }
    //后台接口配置
    API_CONFIG: {
        yufa: "//beta-api.m.jd.com",
        online: "https://api.m.jd.com",
        api_name: "/client.action",
        img_api: "https://pic.jd.com/4/a3363b9a7491486581aeda959abd81ab",
    },
    PAGE_CONFIG: {
        yufa: "https://b2bapp-h5-preview.jd.com",  //页面访问域名
        online: "https://b2bapp-h5.jd.com",
        img_cfg: "//m.360buyimg.com/fenxiaom/"
    },
    // LOGIN_TYPE: 5,
    LOGIN_TYPE: 2,  //登录态类型 1:微信手Q登录 2:H5登录(app内h5使用) 3:PC登录 4:APP登录 5:B2B分销平台登录态(网页上h5使用) 6:金融登录态 7:ERP登录态
    // app是2， web是5
    IOS_VERSIONS: {
        '304': 202104291555,
        '300': 202102231754, //3.0.0版本build值
        '212': 202010242115, //2.1.2版本build值
        '200': 202001151620, //2.0.0版本build值
        '116': 201911281411, //1.1.6版本build值
        '114': 201910251213, //1.1.4版本build值
        '110': 201908181938, //1.1.0版本build值
        '109': 201908011701, //1.0.9版本build值
        '107': 201906101720, //1.0.7版本build值
        '106': 201905291557, //1.0.6版本build值
        '104': 201904112302, //1.0.4版本build值
    },
    SORT_SALES: 'sales_volume', //搜索商品按销量排序
    SORT_ON_SHELF_TIME: 'on_shelf_time_unix', //搜索商品上架时间排序
    SORT_DESC: 'desc', //搜索商品按降序排序
    SORT_ASC: 'asc', //搜索商品按升序排序
    UNIVERSAL_LINk: 'https://fenxiao-m.jd.com/#/app/ios' //ios通用链接
}


// WEBPACK FOOTER //
// ./src/common/js/global.js